<template>
  <v-sheet
    height="100%"
    class="overflow-hidden"
    style="position: relative; margin-top: 0px; border-radius: 0"
  >
    <v-row style="background-color: #E0E0E0; height: 56%;">
      <v-row style="width:100%">
        <p style="    margin-left: 25%; margin-top: 5%;color: #777777;font-size: 56px;">
          Conoce todas las novedades
          <br />de Admira
        </p>
      </v-row>
      <v-row style="width:100%;">
        <v-btn  style="color:#777777;margin-left:43%" rounded depressed medium>Que hay de nuevo</v-btn>
      </v-row>
      <v-row style="width:100%;margin-left: 10%;margin-right: 10%;margin-top: 3%;">
        <v-card style="width:100%">
            <v-row>
                <v-row style="width:100%">
                <p style="margin-left:5%;margin-top:1%">Tus Apps</p>

                </v-row>
                <v-col cols="4">
                  <div style="background-color:red;height:100%;width:100%;margin-left: 20px;">demo</div>
                </v-col>
                <v-col cols="4">
                  <div style="background-color:green;height:100%;width:100%;margin-left: 20px;">demo</div>
                </v-col>
                <v-col cols="4">
                  <div style="background-color:blue;height:100%;width:100%;margin-left: 20px;">demo</div>
                </v-col>
            </v-row>
        </v-card>
      </v-row>
    </v-row>
    <!-- <v-row align="center" style="background-color: #eeeeee" class="px-12">
      <v-col style="flex-grow: 0;">
        <v-icon style="float:left;" right @click="changePage">mdi-arrow-left</v-icon>
      </v-col>
      <v-col style="max-width: fit-content">
        <h4
          style="
            margin-left: 0px;
            font-size: 28px;
            color: #777;
            font-weight: 300;
            text-align: left;
          "
        >
          {{ spaceSelected.name }}
        </h4>
      </v-col>
    </v-row>

    <v-divider />

    <router-view></router-view>
    <v-row
      style="
        height: calc(100vh - 120px);
        overflow: auto;
        background-color: #e0e0e0;
      "
      class="px-10"
    >
      <v-col cols="12" md="8" lg="9" class="pt-0">
        <v-row>
          <v-col id="queues-container" cols="12" md="6">
            <v-card style="border-radius: 20px" class="pb-5">
              <v-row>
                <v-col class="py-0">
                  <QueuesList></QueuesList>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col id="stands-container" cols="12" md="6">
            <v-card style="border-radius: 20px" class="pb-5">
              <v-row>
                <v-col class="py-0">
                  <StandsList></StandsList>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col id="contents-container" cols="12" md="4" lg="3">
        <v-card style="border-radius: 20px" class="pb-5">
          <v-row>
            <v-col class="py-0">
              <CreateContents></CreateContents>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>-->
  </v-sheet>
</template>

<script>
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import router from "vue-router";
// import RightMenuAddNewQueue from "@/components/RightMenuAddNewQueue.vue";
// import RightMenuEditQueue from "@/components/RightMenuEditQueue.vue";
// import ColorPicker from "@/components/ColorPicker.vue";
// import CreateContents from "@/components/CreateContents.vue";
// import StandsList from "@/components/StandsList.vue";
// import QueuesList from "@/components/QueuesList.vue";

export default {
  name: "Queues",
  components: {
    // RightMenuAddNewQueue,
    // RightMenuEditQueue,
    // CreateContents,
    // StandsList,
    // QueuesList,
    // ColorPicker,
  },
  data() {
    return {};
  },
  computed: {
    // ...mapState("app", ["actualProject", "firstProject"]),
    // ...mapState("queues", [
    //   "spaceSelected",
    //   "allResouces",
    //   "objQueueCont",
    //   "objQueueContKiosk",
    //   "allQueues",
    //   "RightMenuAddNewQueue",
    //   "showRightMenu",
    //   "allSpaces",
    //   "RightMenuEditQueue",
    // ]),
  },
  methods: {
    // ...mapMutations("queues", ["setActualSpaceMutation"
    // ]),
    // ...mapActions("queues", [
    //   "getAllQueues",
    //   "getAllSpaces",
    //   "getAllResouces",
    // ]),
    // changePage() {
    //     this.$router.push({
    //         name: "ListSpaces",
    //     });
    // this.closeRightMenuMutation();
    // },
  },

  async created() {
    //      console.log(this.spaceSelected);
    // let idProject = "";
    //     if (this.actualProject == undefined) {
    //       idProject = this.firstProject.id;
    //     } else {
    //       idProject = this.actualProject.id;
    //     }
    //     await this.getAllSpaces(idProject);
    //     await this.getAllResouces(idProject);
    //     await this.getAllQueues(idProject);
    // console.log(this.allSpaces[0]);
    //      console.log(this.spaceSelected);
    // await this.setActualSpaceMutation(this.allSpaces[0]);
  },
  destroyed() {}
};
</script>

<style scoped>
a {
  text-decoration: none;
}
/* >>> .v-data-table__wrapper {
  height: calc(100vh - 207px);
  overflow: auto;
} */
</style>



// WEBPACK FOOTER //
// src/views/desktop/Cloud.vue